import PropTypes from "prop-types";
import { FC, ReactNode } from "react";

const ErrorMessages: FC<{ messages: ReactNode[] }> = ({ messages }) => {
  return (
    <div className="card">
      <div
        className="card-header"
        style={{
          color: "white",
          backgroundColor: "red",
        }}
      >
        Error
      </div>
      <div className="card-content">
        <div className="card-content-inner">
          <ul>
            {messages.map((msg) => (
              <li>{msg}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

ErrorMessages.propTypes = {
  messages: PropTypes.array.isRequired,
};

export default ErrorMessages;
